var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "dropdown",
          rawName: "v-dropdown",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "cafe_dropdown",
      class: _vm.dropdownClass,
      attrs: { id: `dropdown-${_vm.name}` },
    },
    [
      _c("div", { staticClass: "opt_selected", on: { click: _vm.onToggle } }, [
        _c(
          "a",
          { staticClass: "tf_opt" },
          [
            _vm._t("default", function () {
              return [
                _c("span", { staticClass: "txt_selected" }, [
                  _vm._v(_vm._s(_vm.options[_vm.selected])),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ico_cafetop ico_arrow" }, [
                  _vm._v("옵션 더 보기"),
                ]),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "opt_layer" }, [
        _c(
          "ul",
          { staticClass: "list_opt" },
          _vm._l(_vm.options, function (option, index) {
            return _c("dropdown-item", {
              key: "dropdown-" + index,
              attrs: {
                name: option,
                selected: _vm.showSelectedStyle && index === _vm.selected,
              },
              on: { select: _vm.onSelect },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }